/*
 * Scenario: accept-then-undo
 *
 * Reaktives Scenario: ein einzelner Rewrite-Vorschlag, danach — wenn der
 * User akzeptiert hat — ein Hinweis "Press Cmd+Z if you change your mind".
 * Im Browser sieht der Tester, dass der Apply-Schritt durch ein einfaches
 * Undo zurueckgerollt wird (Cursor steht dann am Ende des Original-Texts —
 * neu seit Phase C, siehe EditorModel.replaceParagraphText).
 *
 * Test-Erwartung: das Reminder-Delta wird nur bei applied geschickt.
 */

import { emit, wait, resolve } from './_helpers.js'

export const name = 'accept-then-undo'
export const description = 'One rewrite — after accept, hints at Cmd+Z to undo.'

export async function run(state) {
    const toolCallId = 'tu_atu_' + Date.now().toString(36)

    await emit(state, 'session', { sessionId: 'mock-accept-then-undo' }, 0)
    await emit(state, 'thinking', { text: 'Subtle change — try it, undo if you do not like it.' }, 250)
    await emit(state, 'thinkingDone', {}, 200)

    const paragraphId = resolve(state, '$cursor.paragraphId')
    const originalText = resolve(state, '$cursor.text')
    const baseVersion = resolve(state, '$cursor.version')

    await emit(state, 'proposeRewrite', {
        toolCallId,
        paragraphId,
        baseVersion: typeof baseVersion === 'number' ? baseVersion : undefined,
        originalText: typeof originalText === 'string' ? originalText : '',
        newText: 'A small refinement — barely visible, but it changes the rhythm.',
        reason: 'Reminds the user that Cmd+Z reverts the apply.'
    }, 300)
    await emit(state, 'done', { usage: {} }, 200)

    try {
        const info = await wait(state, toolCallId, 5 * 60 * 1000)
        if (info.result === 'applied') {
            // Reminder — Boris-Wunsch: nach applied auf Cmd+Z hinweisen.
            await emit(state, 'delta', {
                text: 'Applied. Press Cmd+Z (or Ctrl+Z) to undo if you want the original back.'
            }, 250)
        } else {
            await emit(state, 'delta', { text: 'Okay, kept the original.' }, 250)
        }
        await emit(state, 'done', { usage: {} }, 100)
    } catch { /* abort */ }
}
